import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import { Reply } from './Reply';
import { AddReply } from './AddReply';
import * as Config from '../../../configuration/consts';

@withRouter
export class Post extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        var showDetail = this.props.singlePostView || (this.props.item && this.props.item.active) ? true : false;
        this.state = { showLikes: false, showReplies: showDetail, showReplyForm: false, confirmDelete: false, showMenu: false };
        this.onToggleClicked = this.onToggleClicked.bind(this);
        this.onReplyToggleClicked = this.onReplyToggleClicked.bind(this);
        this.onLikeToggleClicked = this.onLikeToggleClicked.bind(this);
        this.onLikeClicked = this.onLikeClicked.bind(this);
        this.onMenuClicked = this.onMenuClicked.bind(this);
        this.onDeleteConfirmClicked = this.onDeleteConfirmClicked.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onAddTagClicked = this.onAddTagClicked.bind(this);
    }

    onToggleClicked() {
        this.setState({ showLikes: false, showReplies: !this.state.showReplies });
    }

    onReplyToggleClicked() {
        let showReplyForm = !this.state.showReplyForm;
        this.setState({ showLikes: false, showReplyForm: showReplyForm });
    }

    onLikeToggleClicked() {
        let showLikes = !this.state.showLikes;
        this.setState({ showLikes: showLikes, showReplyForm: false, showReplies: false,  });
    }

    onMenuClicked() {
        this.setState({ showMenu: !this.state.showMenu });
    }

    onDeleteConfirmClicked() {
        this.setState({ confirmDelete: !this.state.confirmDelete});
    }

    onLikeClicked() {
        this.props.savePostReaction(this.props.forum.id, this.props.currentUser.id, this.props.item.id);
    }

    onDeleteClicked(postId) {
        let post = this.props.forum.posts.find(i => i.id === postId)
        post.Obsolete = this.state.confirmDelete;
        this.props.savePost(this.props.forum.id, post);
    }

    onAddTagClicked(postId, tagId) {
        this.props.addPostTag(postId, tagId);
    }

    onFollowPostClicked(postId, subscribed) {
        this.props.followPost(postId, subscribed);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps != this.props) {
            this.setState({ showMenu: false, confirmDelete: false });

            var showDetail = this.props.item && this.props.item.active === true;
            if(showDetail && this.state.showDetail != showDetail){
                this.setState({showDetail: showDetail});
            }
        }
    }

    checkNestedLevel(parentId){
        /*Check the number of levels this reply is on... only allow for 3 atm */
        let level = 1;
        while (parentId){
           let parent = this.props.forum.posts.find(i => i.id === parentId);
            if(parent){
                parentId = parent.parentId;
            } else {
                parentId = undefined;
            }
            level++; 
        }
        return level < 3;
    }

    render() {

        const { userRole, forum, currentUser, activeFilter, savePost, savePostReaction,singlePostView,  ...props } = this.props;
        const { id, 
                parentId, 
                active, 
                comment, 
                forumMemberId, 
                forumMemberName, 
                creationDate, 
                subscribed, 
                tags, 
                resource, 
                forumMemberAvatarId, 
                link, 
                file, 
                reactions } = this.props.item;
        
            let isAdmin = userRole == Config.ROLE_ADMIN;

            let avatarImg = forumMemberAvatarId ? 
                                        `/api/attachment/${forumMemberAvatarId}` : 
                                        require("../../../assets/img/Unconfirmed.png");

            let children = forum.posts.filter(c => c.parentId === id);
            let childrenCount = !children ? 0 : children.length;

            // Children Replies (recursive)
            let maxCount = this.state.showReplies ? undefined : 2;

            let replySummary = childrenCount <= 2 ? "" :  
                                    !this.state.showReplies ?
                                            <a onClick={this.onToggleClicked} className="clickable"><u>See all comments</u></a> : 
                                            <a onClick={this.onToggleClicked} className="clickable"><u>Hide comments</u></a>;

            let childReplies = forum.posts.filter(p => p.parentId === id).map((i, index) => 
                        {
                            return index < maxCount || !maxCount ? 
                                        <Reply key={"rc" + index} 
                                                    singlePostView={singlePostView} 
                                                    userRole={userRole} 
                                                    item={i} forum={forum} currentUser={currentUser} 
                                                    activeFilter={activeFilter} savePost={savePost} savePostReaction={savePostReaction}/> : undefined; 
                        }) ;
            
            // Split into component (this is a reply)
            let reply = this.state.showReplyForm ? <AddReply defaultSimpleMode={true} parentId={id} {...this.props}/> : undefined;
        
            let deleteAction = currentUser && (currentUser.id == forumMemberId || isAdmin) ? 
                <a className="clickable" onClick={this.onDeleteConfirmClicked}><i className="fa fa-trash-o fa-lg"></i> <span className="small">Delete</span></a> : undefined;

            let deletePrompt = this.state.confirmDelete ? <div className="row">
                <div className="col-12">
                            Are you sure you want to delete?
                            <a className="mx-1 btn btn-danger btn-small clickable" onClick={this.onDeleteClicked.bind(this, id)}>DELETE</a>
                            <a className="mx-1 btn btn-default btn-small clickable" onClick={this.onDeleteConfirmClicked} >CANCEL</a>
                    </div>
            </div> : undefined;

            let deleteHighlight = this.state.confirmDelete ? "card-danger" : undefined;

            
            let likeDetail = this.state.showLikes ? reactions.map((item, index) => {
                    return <span key={index}>{item.name}{index < reactions.length-1 ? "," : ""} </span>;
                }) 
                : reactions.map((item, index) => {
                    return (index < 1) ? <span key={index}>{item.name}</span> : undefined;
                });

            let likeDetail2 = !this.state.showLikes && reactions && reactions.length > 1 ? <span>and {reactions.length - 1} other{reactions.length > 2 ? "s" : ""}</span> : undefined; 
        
            likeDetail = likeDetail && likeDetail.length > 0 ? <a onClick={this.onLikeToggleClicked} >
                        <i className="fa fa-thumbs-up"></i> {likeDetail} {likeDetail2} </a> : undefined;

            let postSummary = <div className="text-muted small">
                <div>
                    {likeDetail}
                </div>
            </div>;

            let likeIcon = reactions.find(i => i.forumMemberId === currentUser.id) != undefined ? 
            <i className="fa fa-thumbs-up fa-lg"></i> : 
            <i className="fa fa-thumbs-o-up fa-lg"></i>;

            let followIcon = subscribed ? <i className="fa fa-star fa-lg" /> : <i className="fa fa-star-o fa-lg" />;     
            let postActions = <div>
                                <span className="mr-3">
                                    <a className="clickable" onClick={this.onLikeClicked}>
                                        {likeIcon} <span className="small">Like</span>
                                    </a>
                                </span>
                                <span className="mr-3">
                                    <a className="clickable" onClick={this.onReplyToggleClicked}><i className="fa fa-comment-o  fa-lg"></i> <span className="small">Comment</span></a>
                                </span>
                                <span className="mr-3">
                                    <a className="clickable" onClick={this.onFollowPostClicked.bind(this, id, subscribed)}><span className="small">
                                    {followIcon} Follow
                                    </span></a>
                                </span>
                                <span>
                                    {deleteAction}
                                </span>
                                </div>;

            postActions = deletePrompt ? deletePrompt : <div>{postActions}{postSummary}</div>;

            let tagsBadges = tags.map((item, index) => {
                    return <span key={index} className="badge badge-pill badge-default">{item.name}</span>
            });

            let tagMenu = forum && forum.tags ? forum.tags.map((item, index) => {
                let added = tags && tags.find(t => t.id == item.id) ? <span className="fa fa-check" style={{ width: "25px"}}></span> : undefined; 
                return item.type == "POST" ? <a key={index} className="dropdown-item" href="#" onClick={this.onAddTagClicked.bind(this, id, item.id)}>{added}{item.name}</a> : undefined
            }) : undefined;


            let directLink = file && file.id ? `/api/attachment/${file.id}` : link ? link : undefined;
            let linkName = file && file.id ? file.fileName : link ? link : "";
            linkName = linkName.length > 30 ? `${linkName.substr(0,30)}...` : linkName;

            let icon = file && file.id ? "paperclip" : link ? "globe" : undefined;
            let downloadLink =  directLink ? <a href={directLink} target="_blank" className="mx-1 my-2">
                                                <i className={`text-muted fa fa-${icon}`} aria-hidden="true"></i> <u>{linkName}</u>
                                            </a> : undefined;

            let showSubMenu = this.state.showMenu ? "show" : "";

            let menu = !parentId && isAdmin ? <span className="pull-right">
                                        <div className={`dropdown ${showSubMenu}`}>
                                            <button className="btn btn-default" style={{ marginTop: "-3px" }} onClick={this.onMenuClicked}>
                                                <span className="fa fa-ellipsis-v"></span>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                    <span>
                                                        <strong className="pl-2">Move post to:</strong>
                                                            {tagMenu }
                                                    </span>
                                            </div>
                                        </div>
                                    </span> : undefined;

            let rootCss = !parentId ? "discussion-board-post" : ""; 
            return (<div id={id} className={`discussion-board card mb-4 ${rootCss} ${deleteHighlight}`} >
                <div className="card-header">
                    <div className="row">
                        <div className="col-2 col-lg-1">
                            <div className="circle-avatar">
                                <img src={avatarImg} />
                            </div>
                        </div>
                        <div className="col-10 col-lg-11">
                            {menu}
                            <span className="pull-right">{tagsBadges}</span>
                            <div className="card-subtitle text-muted">{forumMemberName}</div>
                            <div className="text-muted small">
                                <Moment fromNow>{creationDate}</Moment>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-text">
                    <div className="row">
                        <div className="col-12">
                            <div dangerouslySetInnerHTML={{ __html: comment }}>
                            </div>
                            <div className="py-1">
                                {downloadLink}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-12">
                            {postActions}
                            {reply}
                        </div>
                    </div>
                </div>
                <div className="card-text">
                    <div className="row">
                        <div className="col-12">
                            {childReplies}
                        </div>
                    </div>
                </div>
                <div className="card-text">
                    <div className="row">
                        <div className="col-11 push-1">
                            {replySummary}
                        </div>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/Post.tsx